export function startOfDay(date) {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function addDays(date, amount) {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
}

export function toKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function fromKey(key) {
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function isSameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function daysBetween(from, to) {
  const start = startOfDay(from).getTime();
  const end = startOfDay(to).getTime();
  return Math.round((end - start) / 86400000);
}

export function anchorFromOffset(offset) {
  return addDays(startOfDay(new Date()), offset);
}

export function visibleDates(anchor, columns, startOn) {
  const start = startOn === 'yesterday' ? addDays(anchor, -1) : startOfDay(anchor);
  return Array.from({ length: columns }, (_, index) => addDays(start, index));
}

export function formatDateLabel(date, lang = 'en') {
  if (lang === 'ar') {
    return new Intl.DateTimeFormat('ar', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      numberingSystem: 'latn',
    }).format(date);
  }
  const month = date
    .toLocaleDateString('en-US', { month: 'short' })
    .replace('.', '')
    .toUpperCase();
  return `${month} ${date.getDate()}, ${date.getFullYear()}`;
}

export function formatWeekday(date, lang = 'en') {
  if (lang === 'ar') {
    return new Intl.DateTimeFormat('ar', { weekday: 'long' }).format(date);
  }
  return date.toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();
}

export function weekStartsOn(lang = 'en') {
  return lang === 'ar' ? 6 : 0;
}

export function weekdayHeads(lang = 'en', start = weekStartsOn(lang)) {
  const sunday = new Date(2026, 0, 4);
  return Array.from({ length: 7 }, (_, index) => {
    const date = addDays(sunday, start + index);
    return new Intl.DateTimeFormat(lang === 'ar' ? 'ar' : 'en-US', { weekday: 'narrow' }).format(date);
  });
}

export function monthGrid(monthDate, start = 0) {
  const first = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
  const offset = (first.getDay() - start + 7) % 7;
  const gridStart = addDays(first, -offset);
  return Array.from({ length: 42 }, (_, index) => addDays(gridStart, index));
}
